(function () {

    angular
        .module('smartertoolsApp')
        .controller('invoiceListController', ['$scope', '$timeout', 'invoices', 'cacheControl', 'notificationFactory', '$window', 'authenticationService', invoiceListController]);

    function invoiceListController($scope, $timeout, invoices, cacheControl, notify, $window, authenticationService) {
        var vm = this;
        vm.allInvoicesSearch = '';
        vm.filteredInvoices = [];
        vm.totalFilteredItems = vm.filteredInvoices ? vm.filteredInvoices.length : 0;
        vm.currentPage = 1;
        vm.dateOnServer = Date.now();
        vm.itemsPerPage = 10;
        vm.sortKey = 'DateGeneratedUtc';
        vm.reverse = true;
        vm.countryList = geographicLocations.countries;
        vm.stateList = geographicLocations.statesByCountry;
        vm.generatingDownload = false;

        // Functions
        vm.refresh = refresh;
        vm.getCsvHeader = getCsvHeader;
        vm.getCsvData = getCsvData;
        vm.sort = sort;
        vm.filter = filter;
        vm.selectInvoice = selectInvoice;
        vm.modalShowPage = modalShowPage;
        vm.downloadPdf = downloadPdf;
        vm.sendEmail = sendEmail;
        vm.modalPayInvoice = modalPayInvoice;
        vm.refreshInvoicesAndClosePayModal = refreshInvoicesAndClosePayModal;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refresh();
            $scope.$on('cache-clear', (event, data) => {
                refresh();
            });
        }

        function refresh() {
            $scope.accountCtrl.isLoading++;
            invoices.getInvoices()
                .then((invoices) => {
                    $scope.accountCtrl.isLoading--;
                    vm.allInvoices = invoices;
                    vm.filter();
                    authenticationService.showTermsCondition(
                        (data) => {
                            var showAgreement = data;
                            if (showAgreement == true) {
                                ShowTermsAgreementOverlay();
                            }
                        });
                })
                .catch(function (err) {
                    $scope.accountCtrl.isLoading--;
                });
        }

        function getCsvHeader() {
            return ['Invoice #', 'Created', 'Status', 'Total', 'Items'];
        }

        function getCsvData() {
            var newArr = [];
            for (var i = vm.allInvoices.length - 1; i >= 0; i--) {
                var invoice = vm.allInvoices[i];
                newArr.push({
                    id: invoice.InvoiceNumber + '',
                    created: invoice.DateCreatedUtc,
                    status: invoice.Status,
                    total: '$' + invoice.Total,
                    items: invoice.Items.length
                });
            }
            return newArr;
        }

        function sort(keyName) {
            vm.reverse = vm.sortKey !== keyName || !vm.reverse;
            vm.sortKey = keyName;
        };

        function filter() {
            $timeout(() => vm.totalFilteredItems = vm.filteredInvoices ? vm.filteredInvoices.length : 0, 10);
        };

        function selectInvoice(invoice) {
            vm.selectedInvoice = invoice;
            vm.modalPage = 'start';
            vm.isSending = false;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('invoice-view-modal')).show();
        };

        function modalShowPage(mode) {
            vm.modalPage = mode;
            if (mode == 'email') {
                $timeout(() => document.getElementById('invoiceViewEmailSendAddr').focus(), 100);
            }
            // TODO: Actions and focuses for whatever mode they selected
        }

        function downloadPdf() {
            vm.generatingDownload = true;
            invoices.downloadPdf(vm.selectedInvoice.InvoiceNumber)
                .then((response) => {
                    window.location.href = response.DownloadUrl;
                    vm.generatingDownload = false;
                })
                .catch(() => {
                    notify.error('Unable to generate PDF', 'Error!');
                    vm.generatingDownload = false;
                });
        }

        function sendEmail() {
            if (vm.invoiceViewEmail.$invalid)
                return;
            vm.isSending = true;
            invoices.sendInvoiceEmail(vm.selectedInvoice.InvoiceNumber, vm.emailToSend)
                .then(() => {
                    vm.isSending = false;
                    vm.modalShowPage('email-sent');
                })
                .catch(() => {
                    vm.isSending = false;
                    notify.error('There was a problem sending the email.');
                });
        }

        function modalPayInvoice() {
            vm.isSending = true;
            if (vm.selectedPaymentMethod.PaymentType == 'card') {
                invoices.payExistingCard(vm.selectedInvoice.InvoiceNumber, vm.selectedPaymentMethod)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isSending = false;
                        vm.modalShowPage('pay-results');
                    })
                    .catch(() => {
                        vm.isSending = false;
                        notify.error('There was a problem making the payment.');
                    });
            } else if (vm.selectedPaymentMethod.PaymentType == 'new') {
                invoices.payNewCard(vm.selectedInvoice.InvoiceNumber, vm.selectedPaymentMethod)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isSending = false;
                        vm.modalShowPage('pay-results');
                    })
                    .catch(() => {
                        vm.isSending = false;
                        notify.error('There was a problem making the payment.');
                    });
            }
        }

        function refreshInvoicesAndClosePayModal() {
            cacheControl.clearAllCaches();
            $window.location.reload();
        }
    }

})();